var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCRemove2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_4286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01018 17.2445C8.93911 20.1734 13.6878 20.1734 16.6168 17.2445C19.5457 14.3156 19.5457 9.56683 16.6168 6.6379C13.6878 3.70896 8.93911 3.70896 6.01018 6.6379C3.08124 9.56683 3.08124 14.3156 6.01018 17.2445Z",
    stroke: "#056EE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5561 11.9405H7.07084",
    stroke: "#056EE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3135 7.69788V16.1832",
    stroke: "#056EE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_4286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.3135 0.627441) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCRemove2);
export default __webpack_public_path__ + "static/media/c-remove 2.901750fbde502333b83165bce875e512.svg";
export { ForwardRef as ReactComponent };